import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { APIDeleteVisualizations, APIDeletePresentation, APIDeleteExplainer } from "../../helper/APIFunctions";
const API_LOOKUP = {
  visual: APIDeleteVisualizations,
  presentation: APIDeletePresentation,
  explainer: APIDeleteExplainer,
};
const DeleteModal = (props) => {
  const [isCallingAPI, setIsCallingAPI] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [askConfirm, setAskConfirm] = useState(!props.isLandmark && !!props.vis.favorite);
  const [modalBody, setModalBody] = useState(
    `Are you sure you want to delete "${props.vis.title}"?`
  );

  const handleDelete = () => {
    if (props.isLandmark) {
      props.onVisDelete(props.vis);
      return;
    }

    if (askConfirm) {
      setModalBody(`This ${props.type || 'visual'} is a favorite ${props.type || 'visual'}. Are you really sure you want to delete it?`)
      setAskConfirm(false);
    } else {
      setIsCallingAPI(true);
      setDeleteError(null);
      const APIToCall = API_LOOKUP[props.type || 'visual'];
      APIToCall(
        props.vis,
        (res) => {
          setIsCallingAPI(false);
          props.onVisDelete(props.vis);
        },
        (err) => {
          setDeleteError(err.message || err.error || err);
          setIsCallingAPI(false);
        },
        props.isOrg
      );
    }
  };

  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Body>
        <p className="text-danger text-center">{deleteError}</p>
        <p>{modalBody}</p>
        <Button
          onClick={handleDelete}
          disabled={isCallingAPI}
          className="me-2"
        >
          {isCallingAPI ? (
            <Spinner
              animation="border"
              role="loading"
              className="text-secondary align-center"
              size="sm"
            />
          ) : (
            <>Confirm</>
          )}
        </Button>
        <Button variant="secondary" onClick={props.onHide} disabled={isCallingAPI}>
          Cancel
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
